// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import moment from 'moment';
import Dialog from 'material-ui/Dialog';
import DatePicker from 'react-datepicker';
import FlatButton from 'material-ui/FlatButton';
import './index.css'
class ViewAlbum extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      competition_id:props.competition_id,
      album_list:[ ],
      data_uploaded: false,
      data_error: false,
      addExpenseView:false,
      billView:false,
      bill_source:'',
      add_photos_visible:false,
      to_delete_album:false,
      selected_album: {
        id:null,
        name:'',
        cover_photo:'',
        location:'',
        photos:[],
        description: '',
        organized_on: null,
        album_type: '',
        tag:'',
      },
      selected_album_name:'',
      selected_location:'',
      photo_list:[],
      selected_files:[],
      locations:[],
      disabled:false,
      updating:false,
      page:1,
      loading:true,
      total_pages:1,
      album_types: [],
    };
    
    this.getGalleryDetail = this.getGalleryDetail.bind(this);
    this.ParentCallback = this.ParentCallback.bind(this);
    this.deleteAlbums = this.deleteAlbums.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.updateAlbum = this.updateAlbum.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.onClickAddAlbum = this.onClickAddAlbum.bind(this);
    this.handleLocationChange = this.handleLocationChange.bind(this);
    this.createAlbum = this.createAlbum.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this)
    this.handleDescriptionChange = this.handleDescriptionChange.bind(this)
    this.handleTypeChange = this.handleTypeChange.bind(this)
    this.handleTagChange = this.handleTagChange.bind(this)

  }

  componentDidMount() {
    this.getGalleryDetail();
    window.addEventListener('scroll', this.onScroll, false); 
  }

  ParentCallback(){
    this.setState({add_photos_visible: false})
    this.getGalleryDetail();
  }
  onScroll(){
      if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 500 &&!this.state.loading){
          if((this.state.total_pages>this.state.page)){
              this.setState({page:(this.state.page+1)},()=>{
                  this.getGalleryDetail()
              })
          }
      }
  }
  componentWillUnmount(){
        window.removeEventListener('scroll', this.onScroll, false);        
    }

  getGalleryDetail() {
        const url = `${getLocationOrigin()}/gallery/get_albums_by_location/?page=${this.state.page}`
        const options = {...defaultOptions};
        options['method'] = 'get';
        options['headers'] = {'content-type': 'application/json'}
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data =>{
                var album_list = this.state.album_list
                album_list = [...album_list,...data.albums]
                this.setState({album_list: album_list,loading:false,total_pages:data.num_pages, album_types: data.album_types,album_tags:data.album_tags})
           }) 
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
    }
 
  onViewBill(bill_source){
    this.setState({billView:!this.state.billView,bill_source:bill_source})
  }


  edit_album(album){
    if (album){
        this.onClickAddAlbum()
      this.setState({add_photos_visible: true,selected_album:album,photo_list:album.photos})
    }
    else
      this.setState({add_photos_visible: true})
  }

  add_new_album(){
    this.setState({add_photos_visible: true})
  }  


  deleteAlbums(album_id){
    event.preventDefault();
    if (confirm("Are you sure you want delete?") == true) {
      const url = `${getLocationOrigin()}/tournament/delete_albums/?album_id=${album_id}`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'} 
      options['body'] = JSON.stringify({
                      album_id:album_id,
                      });  
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .catch(error => {
          alert(error.message);
          this.setState({to_delete_album:false})
        })
        .then(data => {
          alert(data.message)
          this.setState({to_delete_album:false})
          window.location.reload()
        });
      } 
    else {
      this.setState({add_photos_visible:false})
    }
  }

albumValid() {
    const requiredFields = [
        { key: 'name', label: 'Album name' },
        { key: 'description', label: 'Description' },
        { key: 'location', label: 'Location' },
        { key: 'album_type', label: 'Album type' },
        { key: 'organized_on', label: 'Event organized date' },
        { key: 'photos', label: 'Photos' }
    ];

    const missingFields = [];

    requiredFields.forEach(field => {
        if (!this.state.selected_album[field.key]) {
            missingFields.push(field.label);
        }
    });

    if (missingFields.length > 0) {
        alert(`The following fields are missing: ${missingFields.join(', ')}`);
        return false;
    }

    return true;
}



    createAlbum(name,formData){
        if(this.albumValid()){
            const url = `${getLocationOrigin()}/gallery/create_album/?name=${name}`
            const options = {...defaultOptions};
            options['method'] = 'get';
            options['headers'] = {'content-type': 'application/json'}
            return fetch(url, options)
               .then(checkStatus)
               .then(parseJSON)
               .then(data => {
                    var selected_album_copy =  Object.assign({}, this.state.selected_album);
                    selected_album_copy['id'] = data.id
                    this.setState({selected_album:selected_album_copy},()=>{
                        formData.append("album_id",this.state.selected_album.id)
                        for(let i=0;i<this.state.selected_files.length;i++){
                            formData.append("photo", this.state.selected_files[i]); 
                            this.updateAlbum(formData,i)
                        }
                    })
                })
               .catch(error => {
                 console.log(error);
                 alert(error.message);
               });
        }
        else{
            this.setState({disabled:false,updating:false})
        }
        
    }
    onClickAddAlbum(){
        const url = `${getLocationOrigin()}/eagleeye/get_cities_eagleeye/`
        const options = {...defaultOptions};
        options['method'] = 'get';
        options['headers'] = {'content-type': 'application/json'}
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({locations: data.cities}))
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
    }
    renderGallery(){
        return(
            <div className="gallery_view col-md-12" >
                <div className="album_view col-md-2">
                    <span className="album_add_button" onClick={() => {this.onClickAddAlbum(),this.setState({add_photos_visible:true})}}>+</span>
                </div>
                <div className="gallery_event" >
                    {this.state.album_list && this.state.album_list.length>0 && this.state.album_list.map((album,index)=>{
                        if(album.photos && album.photos.length>0)
                        {
                            return(
                                <div onClick={() => {this.edit_album(album)}} className="gallery_album">
                                    <div className="gallery_album_name" >{album.name}</div>
                                    <div className="gallery_album_description" >{album.description && album.description.length>100? album.description.slice(0,100)+'...':album.description}</div>
                                    <div className="gallery_album_photo_list">
                                        {album.photos && album.photos.length>0 && album.photos.map((photo,index)=>(
                                            <img className="gallery_album_photo" src={photo.image}/>
                                        ))}
                                    </div>
                                </div>
                            )
                        }})}
                </div> 
            </div>      
        )    
    }
    handleNameChange(event) {
        const value = event.target.value;
        var selected_album_copy =  Object.assign({}, this.state.selected_album);
        selected_album_copy['name'] = value
        this.setState({selected_album: selected_album_copy});
    }
    handleDescriptionChange(event) {
        const value = event.target.value;
        var selected_album_copy =  Object.assign({}, this.state.selected_album);
        selected_album_copy['description'] = value
        this.setState({selected_album: selected_album_copy});
    }
    handleDateChange(date){
        var selected_album_copy =  Object.assign({}, this.state.selected_album);
        selected_album_copy['organized_on'] = date
        this.setState({selected_album: selected_album_copy});
    }
    handleTypeChange(event){
        const value = event.target.value;
        var selected_album_copy =  Object.assign({}, this.state.selected_album);
        selected_album_copy['album_type'] = value
        this.setState({selected_album: selected_album_copy});
    }
    handleTagChange(event){
        const value = event.target.value;
        var selected_album_copy =  Object.assign({}, this.state.selected_album);
        selected_album_copy['tag'] = value
        this.setState({selected_album: selected_album_copy});
    }
    handleLocationChange(event) {
        const value = event.target.value;
        var selected_album_copy =  Object.assign({}, this.state.selected_album);
        selected_album_copy['location'] = value
        this.setState({selected_album: selected_album_copy});
    }
    onPhotoSelect(selectorFiles){
        console.log("onPhotoSelect",this.state.selected_files)
        var selected_files = this.state.selected_files
        for(let i=0;i<selectorFiles.length;i++){
            selected_files.push(selectorFiles[i])
        }
        this.setState({selected_files:selected_files},()=>{
            console.log("onPhotoSelect1",this.state.selected_files)

        })  
    }
    updateAlbum(formData,i){
        const url = `${getLocationOrigin()}/tournament/update_album/`;
        const options = {...defaultOptions}; 
        options['method'] = 'post';
        options['body'] = formData;
        console.log('Going to fetch');
        return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then((response) => {
            if((this.state.selected_files.length == 0) || i+1== this.state.selected_files.length){
                window.location.reload()
            }
        })
        .catch(error => {
            console.log(error);
            alert(error.message);
        });
    }
    handleSubmit(){
        console.log("handleSubmit")
        this.setState({disabled:true,updating:true})
        console.log("updateAlbum",this.state.selected_album)
        var formData = new FormData();
        if(this.state.selected_album.name){
            formData.append("name",this.state.selected_album.name)
        }
        if(this.state.selected_album.location){
            formData.append("location_id",this.state.selected_album.location)
        }
        if(this.state.selected_album.description){
            formData.append("description",this.state.selected_album.description)
        }
        if(this.state.selected_album.album_type){
            formData.append("album_type",this.state.selected_album.album_type)
        }
        if(this.state.selected_album.organized_on){
            formData.append("organized_on",this.state.selected_album.organized_on)
        }
        if(this.state.selected_album.tag){
            formData.append("tag",this.state.selected_album.tag)
        }
        if(this.state.selected_album.id){
            formData.append("album_id",this.state.selected_album.id)
            if(this.state.selected_files.length>0)
                for(var i=0;i<this.state.selected_files.length;i++){
                    formData.append("photo", this.state.selected_files[i]);
                    this.updateAlbum(formData,i)
                }
            else{
                this.updateAlbum(formData,0)
            }
        }
        else{
            console.log("createAlbum")
            this.createAlbum(this.state.selected_album.name,formData)
        }
    }

    deletePhotos(photo_id){
        const url = `${getLocationOrigin()}/tournament/delete_photos/?photo_id=${photo_id}`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'} 
        options['body'] = JSON.stringify({
                          photo_id:photo_id,
                          });  
        return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .catch(error => {
            console.log(error);
            alert(error.message);
        })
        .then(data => {
            alert(data.message)
            window.location.reload()
        });
    }

    
    render() {   
        return(
            <div className="galleryphotos">
                {!this.state.add_photos_visible &&
                  this.renderGallery()
                }
                {this.state.add_photos_visible &&
                    <div className="col-md-12 gallery">
                        <div className="col-md-12 gallery_album_input">
                            <div style={{width:'100%'}} className="col-md-1 gallery_back_btn_box" >
                                <input type="button" className="gallery_back_btn" value="Back"
                                    onClick={() =>{this.setState({add_photos_visible:false,selected_files:[],disabled:false,selected_album:{"name":'',"id":null,"cover_photo":'',"location":'','photos':[], "description": '',"organized_on":null,'album_type': ''} }) }}/>
                            </div> 
                            

                            <div className="gallery_album_name_input_container">
                                <div className="gallery_album_name_input_label">Album Name</div>
                                <input type="text" className="gallery_album_name_input" name="album_name"  value={this.state.selected_album.name} 
                                onChange={this.handleNameChange} placeholder="Album Name"/>
                            </div>

                            <div className="gallery_album_name_input_container">
                                <div className="gallery_album_name_input_label">Description</div>
                                <textarea rows="5" cols="33" className="gallery_album_name_input" name="album_description"  value={this.state.selected_album.description} 
                                onChange={this.handleDescriptionChange} placeholder="Album Description"/>
                            </div>

                            <div className="gallery_album_name_input_container">
                                <div className="gallery_album_name_input_label">Location</div>
                                <select name="location" className="gallery_album_name_input" onChange={this.handleLocationChange} value={this.state.selected_album.location?this.state.selected_album.location:''}>
                                    <option value=''>------</option>
                                    {this.state.locations.length>0 && this.state.locations.map((location,index)=>(
                                        <option value={location.id}>{location.name}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="gallery_album_name_input_container">
                                <div className="gallery_album_name_input_label">Album type</div>
                                <select name="album_type" className="gallery_album_name_input" onChange={this.handleTypeChange} value={this.state.selected_album.album_type?this.state.selected_album.album_type:''}>
                                    <option value=''>------</option>
                                    {this.state.album_types.length>0 && this.state.album_types.map((type,index)=>(
                                        <option value={type.value}>{type.label}</option>
                                    ))}
                                </select>
                            </div>
                            {this.state.selected_album && this.state.selected_album.id&&
                                <div className="gallery_album_name_input_container">
                                    <div className="gallery_album_name_input_label">Album tag</div>
                                    <select name="album_type" className="gallery_album_name_input" onChange={this.handleTagChange} value={this.state.selected_album.tag?this.state.selected_album.tag:''}>
                                        <option value=''>------</option>
                                        {this.state.album_tags.length>0 && this.state.album_tags.map((tag,index)=>(
                                            <option value={tag.value}>{tag.label}</option>
                                        ))}
                                    </select>
                                </div>
                            }
                            <div className="gallery_album_name_input_container">
                                <div className="gallery_album_name_input_label">Event Organized On</div>
                                <div className="gallery_album_name_input" style={{border: 'none', padding: 0, backgroundColor: '#f1f2f7'}}>
                                    <DatePicker selected={this.state.selected_album.organized_on} onChange={this.handleDateChange}/>
                                </div>
                            </div>


                            <div className="gallery_album_name_input_container">
                                <div className="gallery_album_name_input_label"> Photos</div>
                                <div className="gallery_album_name_input" >
                                    <input style={{width:'100%'}}  multiple type="file" name="photo" accept="image/*" onChange={ (e) => this.onPhotoSelect(e.target.files)}/>
                                    <div className="gallery_ablum_file_size">Maximum upload file size : 8MB</div>
                                </div>
                            </div>
                            
                            <div className="album">
                                {this.state.selected_album.photos.length>0&& this.state.selected_album.photos.map((photo,index) =>(
                                    <div key={index} className="photo">
                                        <div className="table">
                                          <img width="150px" height="150px" className="" src={photo.image}></img>  
                                          {photo.id &&<button className="deletepho" onClick={() => {this.deletePhotos(photo.id)}}>x</button>}    
                                        </div>
                                    </div>
                                ))}
                            </div>  
                            {this.state.updating && <div style={{display:'flex',alignItems:'center',fontSize:'30px'}}>Loading....</div>}
                            <div className="gallery_ablum_file_input_box">
                                <input className="gallery_ablum_file_update" value="Update" disabled={this.state.disabled}  type="button" onClick={(e) => this.handleSubmit()}/>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}
export default ViewAlbum;














// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addAlbum/index.js